import { render } from "./CustomDeleteMenu.vue?vue&type=template&id=24c2c20f"
import script from "./CustomDeleteMenu.vue?vue&type=script&lang=js"
export * from "./CustomDeleteMenu.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Programs\\Projects\\www\\cae-new-web\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"CustomDeleteMenu.vue"]])

export default __exports__